import type { QuoteItemSection } from '@paintscout/util/builder'
import { getQuoteOptions, hasFiles } from '@paintscout/util/builder'
import type { PresentationIsEmptyProps } from '../../'

export default function isEmpty({ quote, options }: PresentationIsEmptyProps) {
  const { showQuoteFiles } = getQuoteOptions({
    quote,
    options
  })

  if (!showQuoteFiles) {
    return true
  }

  const consumer = 'customer'
  const sections = ['bid', 'additional', 'added-options', 'pending', 'options'] as QuoteItemSection[]

  if (!hasFiles({ quote, options, sections, consumer, showGroups: true })) {
    return true
  }

  return false
}
